import React from 'react'
import { TemplateProvider } from '~/lib/pdf'
import ResumeProvider from './ResumeProvider'
import {
  templates,
  templateStyle,
  templateSupportedStyles,
  availableFontNames,
} from './templates'

const ContextWrapper = ({
  template_settings,
  template_index,
  children,
  ...props
}) => {
  const templateKey = `template-${template_index}`

  // When a key is removed from default template settings, remove it from stored settings
  const outdatedTemplateKeys = template_settings
    ? Object.keys(template_settings).filter(
        (key) => !templateSupportedStyles[templateKey]?.includes(key),
      )
    : []
  outdatedTemplateKeys.forEach((key) => {
    delete template_settings?.[key]
  })

  // If a font name stored for a template is not registered, set it to the default font
  const fontKeys = ['primaryFontFamily', 'secondaryFontFamily']
  fontKeys.forEach((key) => {
    if (
      template_settings &&
      Object.keys(template_settings).includes(key) &&
      Object.keys(templateStyle[templateKey]).includes(key) &&
      !availableFontNames.includes(template_settings[key])
    ) {
      template_settings[key] = templateStyle[templateKey][key]
    }
  })

  const defaultStyle = template_settings
    ? {
        ...templateStyle,
        [templateKey]: {
          ...templateStyle[templateKey],
          ...template_settings,
        },
      }
    : templateStyle
  const templateProps = {
    templates,
    defaultStyle,
    templateSupportedStyles,
    template_index,
    dev_mode: props.dev_mode,
  }

  return (
    <TemplateProvider {...templateProps}>
      <ResumeProvider {...props}>{children}</ResumeProvider>
    </TemplateProvider>
  )
}
export default ContextWrapper
